<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="400"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>

      <v-form @submit.prevent="onOpenEmployeeSearch">
        <v-card>
          <v-list dark style="background-color: #00479b">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>ค้นหาบุคลากร</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <v-row class="px-4">
            <v-col grow>
              <!-- <v-text-field
                v-model="employee_name"
                hide-details="auto"
                label="ค้นหาบุคลากร"
                outlined
                dense
              /> -->
              <v-autocomplete
                v-model="employee"
                :items="employeeList"
                :loading="isLoadingEmployee"
                :search-input.sync="search"
                no-filter
                dense
                hide-no-data
                hide-selected
                item-text="fullNamePositionTha"
                label=""
                placeholder="กรอกชื่อ-นามสกุล หรือ กรอกชื่อและหน่วยงาน"
                prepend-icon="mdi-magnify"
                return-object
                @change="
                  employee_name = employee.fullNamePositionTha
                  onOpenEmployeeSearch()
                "
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content v-if="!item.loadMore">
                    <v-list-item-title>{{
                      item.fullNamePositionTha
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.emailCMU
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <div
                    v-else
                    class="text-end"
                    @click.prevent="onOpenEmployeeSearch"
                  >
                    <a>
                      ดูเพิ่มเติม
                    </a>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </v-menu>
    <v-dialog v-model="app_list_dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          ระบบที่รองรับการแจ้งเตือน
        </v-card-title>
        <v-card-text>
          <span
            v-for="(text, i) in app_list"
            :key="'applist' + i"
            style="font-size: 16px"
            >- {{ text }}
            <br />
          </span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="closeDialog">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      app_list: [],
      app_list_loading: false,
      app_list_dialog: false,
      menu: false,
      noti: {
        isLine: false,
        isEmail: false,
        isCMUMobile: false,
        isPWA: false
      },
      loading: true,
      employee_name: '',
      isLoadingEmployee: false,
      search: null,
      employees: [],
      employee: {},
      timer: 0
    }
  },

  watch: {
    line: {
      async handler() {
        if (!this.loading) {
          try {
            const res = await this.apiPostSelfNoti({
              isLine: this.line
            })
            if (res) {
              window.location = res
            }
          } catch (e) {
            console.log(e)
          }
        } else {
          this.loading = false
        }
      }
    },
    email: {
      async handler() {
        await this.apiPostSelfNoti({
          isEmail: this.email
        })
      }
    },
    search(val) {
      if (!val || val.length < 3) return

      this.isLoadingEmployee = true
      this.employee_name = val

      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.onSearchEmployee()
        this.timer = null
      }, 500)
    }
  },

  computed: {
    line() {
      return this.noti.isLine
    },
    email() {
      return this.noti.isEmail
    },
    cmu_mobile() {
      return this.noti.isCMUMobile
    },
    pwa() {
      return this.noti.isPWA
    },
    employeeList() {
      if (this.isLoadingEmployee) return []

      let item = this.employees
      if (item.length > 4) {
        item = item.slice(0, 4)
      }
      if (item.length !== 0) {
        item.push({ fullNamePositionTha: this.employee_name, loadMore: true })
      }
      return item
    }
  },

  async mounted() {
    this.noti = await this.apiGetSelfNoti()
    if (!this.line) {
      this.loading = false
    }
  },

  methods: {
    async openDialog() {
      this.app_list_loading = true
      this.app_list = await this.apiGetAppService()
      this.app_list_loading = false
      this.app_list_dialog = true
      this.menu = false
    },

    closeDialog() {
      this.app_list_dialog = false
      this.menu = true
    },

    async apiGetAppService() {
      try {
        const res = await this.$store.dispatch('dashboard/getAppService')
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetSelfNoti() {
      try {
        const res = await this.$store.dispatch('dashboard/getSelfNoti')
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiPostSelfNoti(body) {
      try {
        const res = await this.$store.dispatch('dashboard/postSelfNoti', body)
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    onOpenEmployeeSearch() {
      window.open('/employee-search?name=' + this.employee_name, '_blank')
      this.clearEmployeeSearch()
    },

    clearEmployeeSearch() {
      this.employee_name = ''
      this.employees = []
      this.employee = {}
      this.search = null
    },

    async onSearchEmployee() {
      try {
        const res = await this.$store.dispatch(
          'employee/getEmployeeInfo',
          this.employee_name
        )
        this.employees = res.data.data
        this.isLoadingEmployee = false
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
